module.exports = __webpack_public_path__ + "media/7.d123ed80.mp3";